import type {
  BillingTransactionResource,
  BillingTransactionTypeResource,
} from '@/features/billing/api/resources/billing-transaction'
import type {
  BillingTransactionProps,
  BillingTransactionType,
} from '@/features/billing/transactions/BillingTransaction'
import { Id } from '@/infra/id'
import { maybeParseDate, unixEpoch } from '@/utils/date-util'

/**
 * Maps a billing transaction.
 */
export function mapBillingTransactionResourceToProps(
  resource: BillingTransactionResource,
): BillingTransactionProps {
  return {
    id: resource.id,
    amount: resource.amount,
    billingMethodId: Id(resource.billing_method_id),
    payoutMethodId: Id(resource.payout_method_id),
    dateCreated: maybeParseDate(resource.date_created) ?? unixEpoch(),
    transactionType: mapBillingTransactionTypeResourceToBillingTransactionType(
      resource.transaction_type,
    ),
    refundTargetTransaction: resource.refund_target_transaction ?? '',
    version: resource.version,
    receiptUrl: resource.metadata.receipt_url,
  }
}

function mapBillingTransactionTypeResourceToBillingTransactionType(
  type: BillingTransactionTypeResource,
): BillingTransactionType {
  switch (type) {
    case 'DEPOSIT':
      return 'Deposit'
    case 'PURCHASE':
      return 'Purchase'
    case 'BONUS':
      return 'Bonus'
    case 'ADMIN_ADD':
      return 'AdminAdd'
    case 'ADMIN_REMOVE':
      return 'AdminRemove'
    case 'REFUND':
      return 'Refund'
    case 'PAYOUT':
      return 'Payout'
    default:
      // The API may send values this build doesn't know yet.
      return 'Unknown'
  }
}
